export const removeFontTags = (innerHTML: string): string => {
  if (!innerHTML) {
    return innerHTML;
  }

  return innerHTML.replace(/<\/?font[^>]*>/g, '');
};
